module.exports = __webpack_public_path__ + "static/media/view award.93c3a65b.svg";